var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature-pad"},[_c('canvas',{ref:"canvas",on:{"mousedown":_vm.startDrawing,"mousemove":_vm.draw,"mouseup":_vm.stopDrawing,"mouseleave":_vm.stopDrawing}}),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('button',{on:{"click":_vm.clear}},[_vm._v("清除")]),_vm._v(" "),_c('button',{on:{"click":_vm.save}},[_vm._v("保存")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bced669","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignaturePad.vue
// module id = null
// module chunks = 